import { render, staticRenderFns } from "./ContractGoodsList.vue?vue&type=template&id=051eb6a4"
import script from "./ContractGoodsList.vue?vue&type=script&lang=js"
export * from "./ContractGoodsList.vue?vue&type=script&lang=js"
import style0 from "./ContractGoodsList.vue?vue&type=style&index=0&id=051eb6a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports